<template>
	<v-combobox
		v-model="model"
		:items="items"
		:label="label"
		:outlined="outlined"
		:dense="dense"
		item-text="name"
		item-value="id"
		:hide-details="hideDetails"
		:clearable="clearable"
		:loading="loading"
		:rules="rules"
		return-object
	>
		<template v-slot:item="{ on, item }">
			<v-list-item v-on="on">
				<v-list-item-content>
					<v-list-item-title>{{ item.name }}</v-list-item-title>
					<v-list-item-subtitle>{{ item.yearFrom }} - {{ item.yearTo }}</v-list-item-subtitle>
				</v-list-item-content>
			</v-list-item>
		</template>
	</v-combobox>
</template>

<script>
import mixin from './mixin/main'
import { mapGetters, mapActions } from 'vuex'
export default {
	mixins: [mixin],
	props: {
		brandmodel:	{ type: Object, default: null },
	},
	watch: {
		brandmodel(item) {
			this.onRefresh(item)
		},
	},
	computed: {
		...mapGetters('VehicleGeneration', [ 'items' ]),
	},
	methods: {
		...mapActions('VehicleGeneration', [ 'load', 'setItems' ]),

		onLoad() {
			if(this.brandmodel) {
				this.loading = true;
				this.load({model: this.brandmodel}).then(() => {
					this.setDefault();
				}).finally(() => (this.loading = false));
			}
		},
	},
}
</script>